import Service from "../AuthService";
import Service2 from "../Service2";

const dataDev = {

    getAllDevData() {
        return Service.get(`/api/developerdata/all`);
    },
    addDevData(data) {
        return Service.post(`/api/developerdata/add`,data)
    },
    updateDevData(id,data) {
        return Service.put(`/api/developerdata/update/${id}`,data )

    },
    deleteDevData(id) {
        return Service.delete(`/api/developerdata/${id}` )
    },
    importExcel(data) {
        return Service.post(`/api/developerdata/import-excel` , data)
    },
    
    /**
     * Author: thiracupt ponngern
     * Details: get group ckan
     */
    getGroupCkan() {
        return Service.get(`/api/groupCkan/all`);
    },
    getAllGroupCkan() {
        return Service2.get(`/systemadmin/api/getGroup`);
    }

};

export default dataDev;
